// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"0189e6423cd6e649a193","136":"16f8f3e8d84a99572945","137":"acb46eef3bfbdacffcac","186":"7bdcf3beb29f46016e9b"}[chunkId] + ".chunk.js";
};